<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';

export const BaseBodyTextRegistration: BuilderComponent = {
  name: 'Base Body Text',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Base Body text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
  inputs: [
    {
      name: 'underline',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    tag?: TypographyTags;
    underline?: boolean;
  }>(),
  {
    tag: 'p',
  },
);
</script>

<template>
  <component
    :is="tag"
    class="text-sm base-text lg:text-base lg:leading-6"
    :class="{ underline: underline }"
  >
    <slot />
  </component>
</template>

<style scoped>
.base-text {
  @apply mb-0;
}
.title {
  @apply leading-4 lg:leading-5;
}
</style>
